import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Box, Grid, Typography } from '@material-ui/core'
import { getPostGraduateCategory } from '../PostGraduation.constants'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import SearchInput from 'src/components/SearchInput/SearchInput'
import EmptyState from 'src/components/EmptyState/EmptyState'
import InfoCard from 'src/components/InforCard/InfoCard'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostGraduationSearchContent.styles'

const postGraduations = [
  {
    id: 'rsc-2022',
    title: 'Residência em Segurança Cibernética 2022',
    status: 'encerrado'
  },
  {
    id: 'rsc-2026',
    title: 'Residência em Segurança Cibernética 2026',
    status: 'em vigor'
  }
]

const PostGraduationSearchContent = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const location = useLocation()
  const query = useMemo(() => {
    const searchParam = new URLSearchParams(location.search).get('q') || ''
    return decodeURIComponent(searchParam).trim()
  }, [location.search])
  const results = postGraduations.filter((item) =>
    item.title.toLowerCase().includes(query.toLowerCase())
  )
  return (
    <Box className={globalClasses.containerPages}>
      <Box className={globalClasses.topPageBreadcrumbsSearch}>
        <BreadcrumbsComponent
          crumbs={[
            {
              label: t('navbar.start'),
              path: '/'
            },
            {
              label: t('navbar.postgraduate'),
              path: '/postgraduate'
            },
            {
              label: t('post-graduation.result-title')
            }
          ]}
        />
        <SearchInput
          redirectUrl="/postgraduate/search"
          placeholder={t('post-graduation.search-placeholder')}
          initialValue={query}
        />
      </Box>
      <Box className={classes.root}>
        <Typography className={classes.title}>
          {t('post-graduation.showing')} {results.length}{' '}
          {t('post-graduation.results-for')}: {query}
        </Typography>
        {results.length > 0 ? (
          <Grid container spacing={4}>
            {results.map((course) => (
              <Grid item xs={12} sm={6} md={4} key={course.id}>
                <InfoCard
                  title={course.title}
                  category={getPostGraduateCategory(course.status)}
                  actionLabel={t('post-graduation.view-more')}
                  link={`/postgraduate/${course.id}`}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box width="100%">
            <EmptyState searchTerm={query} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default PostGraduationSearchContent
